import { Box, CircularProgress } from '@mui/material';

interface Props {
  label: string;
  onClick: () => void;
  isLoading?: boolean;
}

function ShowAllLink({ label, onClick, isLoading = false }: Props) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={isLoading}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: 'none',
        border: 'none',
        padding: 0,
        marginTop: '28px',
        color: 'primary.main',
        cursor: isLoading ? 'default' : 'pointer',
        typography: 'h5',
        fontWeight: 700,
      }}>
      {label}
      {isLoading && (
        <CircularProgress size={14} sx={{ color: 'primary.main' }} />
      )}
    </Box>
  );
}

export default ShowAllLink;
